import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import MobileHeaderDropdownMenu from "./MobileHeaderDropdownMenu";
import { useWallet } from "@solana/wallet-adapter-react";
import { useState, useEffect, useRef } from 'react';
import Lottie from "lottie-react";
import walletAnimation from "../../lotties/wallet_14659858.json"

const CustomWalletButton = () => {
  const { connected, publicKey } = useWallet();
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);
  const walletButtonRef = useRef(null);

  const shortenAddress = (address) => {
    if (!address) return '';
    return `${address.toString().slice(0, 4)}...${address.toString().slice(-4)}`;
  };

  const handleClick = () => {
    setIsAnimating(true);
    // Find and click the actual wallet button
    const walletButton = document.querySelector('.wallet-adapter-button');
    if (walletButton) {
      walletButton.click();
    }
    setTimeout(() => setIsAnimating(false), 1000);
  };

  return (
    <div className="relative flex items-center">
      {/* Original WalletMultiButton - visible but with 0 opacity */}
      <div className="absolute opacity-0 pointer-events-none">
        <WalletMultiButton ref={walletButtonRef} />
      </div>
      {/* Custom Wallet Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="flex items-center gap-2 bg-[#22C8BF]/10 hover:bg-[#22C8BF]/20 border border-[#22C8BF] rounded-lg p-2 transition-all duration-300"
      >
        <div className="w-8 h-8">
          <Lottie
            animationData={walletAnimation}
            loop={isHovered || isAnimating}
            autoplay={isHovered || isAnimating}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
        <span className="text-sm text-[#22C8BF] hover:text-[#22C8BF] pr-2">
          {connected ? shortenAddress(publicKey) : 'Connect'}
        </span>
      </button>
    </div>
  );
}

const MobileHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 1000);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`lg:hidden flex justify-between items-center py-3 px-4 fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/90 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}>
      <div className="flex items-center gap-1">
        <img
          src="/static/images/Logo.svg"
          className="w-8 h-8 sm:w-[30px] sm:h-[30px]"
          alt="taptool"
        />
      </div>
      <div className="flex items-center gap-4">
        <CustomWalletButton />
        <div className="flex items-center">
          <MobileHeaderDropdownMenu />
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
